module.exports = __webpack_public_path__ + "static/img/lmp_logo@2x.fdd8ded.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/2x/lmp_logo@2x.png
// module id = QXtr
// module chunks = 1